<ng-container *ngIf="deal$ | async as deal">
    <mg-preview-model-3
        *ngIf="deal.modelName === 'Model 3'"
        [influencingValues$]="influencingValues$"
    ></mg-preview-model-3>
    <mg-preview-model-y
        *ngIf="deal.modelName === 'Model Y'"
        [influencingValues$]="influencingValues$"
    ></mg-preview-model-y>
    <mg-preview-model-s
        *ngIf="deal.modelName === 'Model S'"
        [influencingValues$]="influencingValues$"
    ></mg-preview-model-s>
    <mg-preview-model-x
        *ngIf="deal.modelName === 'Model X'"
        [influencingValues$]="influencingValues$"
    ></mg-preview-model-x>
</ng-container>
